export enum DurationType {
  timespan               = 0,
  fixedDate              = 1,
  atAward                = 2,
  atSubmission           = 3,
  atExpiry               = 4,
  never                  = 5,
  fixedDateAfterTimeSpan = 6,
  customFormula          = 7,
  propertyBasedTimeSpan  = 8,
  datePicker             = 9,
}